import { logger } from 'packages';
import api from './api';
import { setFetching, setCartData } from './reducer';
import * as analytics from 'tradera-apps/tradera/components/vip/helpers/analytics';
import cookieUtil from 'tradera-utils/cookie';
import { CART_ID } from 'tradera-constants/cookies';

export const fetchCartData = cartId => async dispatch => {
    dispatch(setFetching(true));

    try {
        const checkoutData = await api.getCartOverview(cartId);

        const { data } = checkoutData;

        dispatch(setCartData(data));
    } catch (error) {
        logger(error);
        dispatch(setFetching(false));
    }
};

export const addItemToCart = (
    cartId,
    itemId,
    price,
    onSuccess
) => async dispatch => {
    dispatch(setFetching(true));

    try {
        const addItemResult = await api.addItemToCart(cartId, itemId, price);
        if (addItemResult.status === 200) {
            cartId = addItemResult.data.cartId;
            let date = new Date();
            date.setMonth(date.getMonth() + 2);
            cookieUtil.createCookie(CART_ID, cartId, date);
        }
        await api.updateCartSummary(cartId);
        onSuccess();
    } catch (error) {
        logger(error);
        dispatch(setFetching(false));
    }
};

export const removeItemsFromCart = (cartId, itemIds) => async dispatch => {
    dispatch(setFetching(true));

    try {
        await api.removeItemsFromCart(cartId, itemIds);
        await api.updateCartSummary(cartId);
        dispatch(fetchCartData(cartId));
    } catch (error) {
        logger(error);
        dispatch(setFetching(false));
    }
};

export const setCartItemQuantity = (
    cartId,
    itemId,
    quantity
) => async dispatch => {
    dispatch(setFetching(true));

    try {
        await api.setCartItemQuantity(cartId, itemId, quantity);
        await api.updateCartSummary(cartId);
        dispatch(fetchCartData(cartId));
    } catch (error) {
        logger(error);
        dispatch(setFetching(false));
    }
};

export const confirmCartPurchase = (
    cartId,
    shopItems,
    onSuccess
) => async dispatch => {
    dispatch(setFetching(true));

    try {
        const confirmData = await api.confirmCartPurchase(
            shopItems,
            analytics.getGaTrackingData()
        );

        // Update cart but don't dispatch as we will reload anyway
        await api.removeItemsFromCart(
            cartId,
            shopItems.map(item => item.itemId)
        );
        await api.updateCartSummary(cartId);
        const { data } = await api.getCartOverview(cartId);
        setCartData(data);

        onSuccess(confirmData.data.purchaseOrderId);
    } catch (error) {
        logger(error);
        dispatch(setFetching(false));
    }
};

export const startOffPlatformCheckout = (
    itemId,
    onSuccess
) => async dispatch => {
    dispatch(setFetching(true));

    try {
        await api.startOffPlatformCheckout(itemId);
        onSuccess();
    } catch (error) {
        logger(error);
        dispatch(setFetching(false));
    }
};
